import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import HeaderBtn from "./HeaderBtn";
import { CgMenuGridR, CgMenu } from "react-icons/cg";
import { TbArrowLoopLeft } from "react-icons/tb";
import HeaderVert from "./HeaderVert";

import { useAnalyticsEventTracker } from "./Tracker";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const homeActive = location.pathname === "/home";
  const simActive = location.pathname === "/simulator";
  const blenderActive = location.pathname === "/";

  const [isOpen, setIsOpen] = useState(true);

  // Small screen menu
  const [verticalOpen, setVerticalOpen] = useState(false);

  const closeVertMenu = () => {
    setVerticalOpen(false);
  };

  const gaEventTracker = useAnalyticsEventTracker("Test Button");

  return (
    <div className={`${blenderActive && "hidden"}`}>
      <button
        className={`md:hidden fixed top-4 right-5 z-50
                              text-white text-right text-3xl ${
                                simActive &&
                                (isOpen ? "text-white" : "text-[#3d3935]")
                              }`}
        onClick={(e) => {
          e.stopPropagation();
          setVerticalOpen(!verticalOpen);
        }}
      >
        <CgMenu />
      </button>
      {verticalOpen && (
        <div
          className="bg-gray-500 bg-opacity-50 md:hidden w-full h-full fixed top-0 z-20"
          onClick={() => setVerticalOpen(false)}
        ></div>
      )}
      <div className="relative z-50">
        <div
          className={`absolute top-12 mt-2 right-0 md:hidden duration-700 origin-top
                                    ${!verticalOpen && "scale-y-0"}`}
        >
          <HeaderVert closeVertMenu={closeVertMenu} />
        </div>
      </div>

      <div
        className={`fixed top-0 py-2 left-0 pl-36 z-10 h-16
                             flex space-x-8 items-center
                            text-white duration-300
                            ${
                              simActive & isOpen &&
                              "bg-[#3d3935] bg-opacity-95 shadow-xl"
                            }
                            ${
                              blenderActive & isOpen &&
                              "bg-slate-400 bg-opacity-95"
                            }
                            ${
                              isOpen
                                ? "w-full"
                                : simActive
                                ? "w-52 text-[#3d3935]"
                                : "w-52"
                            }`}
      >
        <div
          className={`flex text-xl xl:mr-48 lg:mr-32
                                 hover:cursor-pointer
                                ${
                                  isOpen ? "-ml-28 lg:ml-0" : "-ml-32"
                                } duration-500`}
        >
          <div className="flex" onClick={() => navigate("/")}>
            <p className="">emotional</p>
            <p className="font-bold">DNA</p>
          </div>

          {!isOpen && (
            <button
              className={`hidden md:inline-flex ml-2 text-3xl hover:ring-2 hover:ring-white ${
                simActive && "text-[#3d3935]"
              }`}
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              <CgMenuGridR />
            </button>
          )}
        </div>

        {isOpen && (
          <div
            className="hidden md:flex items-center
                                xl:space-x-8 xl:text-base
                                lg:opacity-100 lg:text-sm
                                "
          >
            <HeaderBtn
              title="Products"
              list={[
                { title: "Simulator", to: "/simulator" },
                { title: "Blender", to: "/" },
              ]}
            />
            <button
              className="w-20 hover:font-semibold"
              onClick={() => gaEventTracker("resources")}
            >
              Resources
            </button>
            <button
              className="w-24 hover:font-semibold"
              onClick={() => gaEventTracker("demo")}
            >
              Get a Demo
            </button>
            <button
              className="w-20 hover:font-semibold"
              onClick={() => gaEventTracker("contact")}
            >
              Contact
            </button>
            <button className="w-20 hover:font-semibold">Log in</button>
            <button
              className="bg-white bg-opacity-25 px-6 py-2.5 rounded-full hover:font-semibold"
              onClick={() => gaEventTracker("trial")}
            >
              Free Trial
            </button>

            {!homeActive && (
              <button className="text-xl absolute right-3">
                <TbArrowLoopLeft
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Header;
